import React, { useEffect } from "react";
import Listing from "../../Listing";
import Header from "../../../../layout/Header";
import Footer from "../../../../layout/Footer";
import { useDispatch, useSelector } from "react-redux";
import HeroSection from "../../../../layout/HeroSection";
import { pageRoutes } from "../../../../routes/pageRoutes";
import { fetchlessonReceivers } from "../../../../redux/action/lessonsAction";
import Loader from "../../../../components/other/Loader";
import SecureContent from "../../../../components/secureContent";

const Receivers = () => {
  const dispatch = useDispatch();
  const { receiversList, isLoading } = useSelector(
    (state) => state?.lessonsReducer
  );

  useEffect(() => {
    dispatch(fetchlessonReceivers());
  }, []);

  if (isLoading) {
    return <Loader />;
  }
  return (
    <>
      <div>
      <SecureContent/>
      <Header />
        <HeroSection
          label={<h1 class="mb-3">{"Receivers"}</h1>}
          breadcrumbItems={[
            { name: "Home", path: `${pageRoutes?.home}/` },
            {
              name: "Electrical engineering and robot combat",
              path: pageRoutes?.lessons?.electricalEngineering,
            },
            { name: "Receivers", path: `${pageRoutes?.home}/` },
          ]}
        />

        <Listing contentData={receiversList} color={"#36296c"} />

        <Footer />
      </div>
    </>
  );
};

export default Receivers;
